// @ts-nocheck
import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { ProductCatalogModel } from "@store/Framework/Types/ApiModels";

export interface GetProductCatalogsApiParameter extends ApiParameter {
    categoryName?: string;
    catalogName?: string;
}

const storeAccountsUrl = "/api/v1/accounts/store";

export function getCatalogsList() {
    return get<ProductCatalogModel>(`${storeAccountsUrl}/list`);
}

export async function getCatalogService(categoryName: string, catalogName: string) {
    const uri = `${storeAccountsUrl}/getcatalog/${categoryName}/${catalogName}`;

    try {
        const fileResponse = await fetch(uri);
        if (!fileResponse || !fileResponse.ok) {
            throw Error;
        }
        return {
            successful: true,
            result: fileResponse,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: error.errorJson.message,
        };
    }
}

export function getGeneralDocumentationsList() {
    return get<string[]>(`${storeAccountsUrl}/listDocuments`);
}

export function getDocument(documentName: string): void {
    const uri = `${storeAccountsUrl}/getDocument/${documentName}`;
    window.open(uri, "_blank");
}
